import React, { Fragment, useState } from "react";
import { isMobile } from "react-device-detect";
import { Dialog } from "@material-ui/core";
import SbTaskForm from "./SbTaskForm";
import { DownloadSbSampleFile, DownloadSbTemplateFile } from "../apiService";
import { convertFilterObject, removeEmptyKey, permissionCheckFnforCamo } from "../../../../utils";
import { smbcInstance } from "../../../../shared_elements/components";
import CamoCTA from "../../../../shared_elements/components/cta/CamoCTA";

const SbSearchBar = ({ applyingFilter, filterOptions, tabIndex, pageLoader, props, searchData, fileUploadData, importFile, exportReportFn, currentRecordPerPage, headerData, headerTsn, headerCsn, uuid, getResponseBack, basicDetails }) => {
	const [open, setOpen] = useState(false);
	const [formTitle, setFormTitle] = useState("");
	const [actionType, setActionType] = useState("");

	const params = new URLSearchParams(props.location?.search);
	const queryValue = params.get('query');

	const addNewTask = () => {
		setOpen(true);
		setFormTitle("SB Components");
		setActionType("add");
	};

	const importFileFunc = (e) => {
		const files = e.target.files;
		const formData = new FormData();
		formData.append("file", files[0]);
		importFile(formData, props, true);
		e.target.value = null;
	};

	const filterParams = convertFilterObject(removeEmptyKey(applyingFilter), filterOptions);

	return (
		<Fragment>
			<div id="AmpSearchBar">
				<CamoCTA
					searchPlaceholder={smbcInstance ? "Search SB Reference Number, SB Description" : "SB Reference Number, SB Description, SB Type"}
					defaultSearchValue={queryValue || ''}
					onSearch={(value) => setTimeout(() => searchData(value), 1000)}
					permissionCheck={!permissionCheckFnforCamo({ primaryKey: "sb_status", keyIndex: "C" }) || window?.location?.search.includes('archived-assets')}
					addLabel="ADD SB STATUS"
					onAddFn={addNewTask}
					onImportFn={importFileFunc}
					exportMenu={{
						exportReportFn: exportReportFn,
						files: [
							{ title: 'PDF', extension: 'pdf', key: '' },
							{ title: 'EXCEL', extension: 'xlsx', key: '' },
						],
					}}
					downloadSampleMenu={{
						exportReportFn: (file) => file.key === 'template'
							? DownloadSbTemplateFile({ download: file.extension, ...filterParams }, pageLoader, props, basicDetails)
							: DownloadSbSampleFile({ download: file.extension, ...filterParams }, pageLoader, props, basicDetails),
						files: [
							{ title: 'DOWNLOAD SAMPLE', extension: 'xlsx', key: 'sample' },
							{ title: 'TEMPLATE', extension: 'xlsx', key: 'template' },
						],
					}}
				/>
				<Dialog open={open} style={{ height: isMobile && "650px" }}>
					<SbTaskForm
						formTitle={formTitle}
						closeAddForm={() => setOpen(false)}
						addForm={() => setOpen(true)}
						props={props}
						headerTsn={headerTsn}
						headerCsn={headerCsn}
						actionType={actionType}
						fileUploadData={fileUploadData}
						currentRecordPerPage={currentRecordPerPage}
						headerData={headerData}
						uuid={uuid}
						basicDetails={basicDetails}
						getResponseBack={() => getResponseBack()}
					/>
				</Dialog>
			</div>
		</Fragment>
	);
};

export default SbSearchBar;
